import { render } from "./PrizePictureList.vue?vue&type=template&id=15b8273f&scoped=true"
import script from "./PrizePictureList.vue?vue&type=script&lang=js"
export * from "./PrizePictureList.vue?vue&type=script&lang=js"

import "./PrizePictureList.vue?vue&type=style&index=0&id=15b8273f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b8273f"]])

export default __exports__